import React from 'react';
import { Box, Typography } from '@mui/material';
import UnificarProduto from '../components/produto/UnificarProduto';

const ProdutoUnificar: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold' }}>
        Unificar Produto
      </Typography>
      <UnificarProduto />
    </Box>
  );
};

export default ProdutoUnificar;
